<template>
    <div>
      <ul class="flex bg-[#2B2C32] rounded-full py-1 mb-2">
        <li :class="'mr-4' + (activeTab == 'location' ? ' active' : '')">
          <a href="#" @click.prevent="changeTab('location')" class="inline-block text-theme-white tracking-widest text-sm font-semibold px-2 upper">
            Location Analytics 
          </a>
        </li>
        <li :class="activeTab == 'business' ? ' active' : ''">
          <a href="#" @click.prevent="changeTab('business')" class="text-theme-theme-white tracking-widest text-sm font-semibold upper">
            Business Analytics
          </a>
        </li>
      </ul>
    </div>
  </template>

activeTab
<script lang="ts">
import {defineComponent} from "vue"



export default defineComponent({
  name: "ReportGeneration",
  props: {
    activeTab: {
      type: String,
      required: true
    },
    changeTab:{
      type: Function,
      required: true
    }
  }
})

</script>

  
  <style scoped>
    .active:before {
      content: '';
      position: absolute;
      background: #2BA66B;
      width: 100%;
      height: 4px;
      bottom: -8px;
    }
    .active {
      position:relative;
    }
  </style>